import type { SerializedStyles } from "@emotion/serialize";
import type { ReactNode } from "react";

import { Container } from "@aviary/layouts";
import { Banners } from "@shared/components/Banners/Banners";

import * as styles from "./StickyNavigation.styles";

interface Props {
  children: ReactNode;
  customStyles?: { stickyNavigation: SerializedStyles; mainNav: SerializedStyles };
}

const StickyNavigation = ({ children, customStyles }: Props) => {
  const stickyNavigationStyles = [styles.stickyNavigation, customStyles?.stickyNavigation];
  const navStyles = [styles.mainNav, customStyles?.mainNav];

  return (
    <div css={stickyNavigationStyles}>
      <div css={styles.stickyContainer}>
        <div css={navStyles}>
          <Container css={styles.container}>{children}</Container>
        </div>
        <Banners />
      </div>
    </div>
  );
};

export { StickyNavigation };
